module.exports = "/assets/festival-banners/listing-banner-rw-mobile.png?5x2hldW";